import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import AppHeader from './AppHeader';
import BottomNav from './BottomNav';

const MainLayout = () => {
  return (
    <Container>
      <AppHeader />
      <Content>
        <Outlet />
      </Content>
      <BottomNav />
    </Container>
  );
};

export default MainLayout;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  overflow: hidden;
`;

const Content = styled.main`
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
`;
